import { Apple, Smartphone } from 'lucide-react';

export const AppPromoBanner = () => {
  return (
    <section className="py-24 bg-[#F7F8FA]">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="relative bg-white border-2 border-[#FF6A2A] rounded-[24px] overflow-hidden shadow-lg">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left: Text and Buttons */}
            <div className="p-10 lg:p-16">
              <div className="inline-block px-3 py-1 bg-[#FFF5F0] text-[#FF6A2A] text-xs font-semibold rounded-full mb-4 uppercase tracking-wide">
                Disponible ahora
              </div>
              <h2 className="mb-4">Descarga la app gratis</h2>
              <p className="text-[#6B7280] text-lg mb-8 leading-relaxed">
                Lleva Mexmo contigo a donde vayas. Disponible para iOS y Android.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                {/* Google Play Button */}
                <a 
                  href="#" 
                  className="inline-flex items-center gap-3 bg-[#111827] text-white px-6 py-3.5 rounded-[14px] font-medium hover:bg-[#1F2937] transition-all shadow-sm"
                >
                  <Smartphone className="w-6 h-6" />
                  <div className="text-left">
                    <div className="text-xs opacity-70">Disponible en</div>
                    <div className="font-semibold">Google Play</div>
                  </div>
                </a>
                
                {/* App Store Button */}
                <a 
                  href="#" 
                  className="inline-flex items-center gap-3 bg-[#111827] text-white px-6 py-3.5 rounded-[14px] font-medium hover:bg-[#1F2937] transition-all shadow-sm"
                >
                  <Apple className="w-6 h-6" />
                  <div className="text-left">
                    <div className="text-xs opacity-70">Descarga en</div>
                    <div className="font-semibold">App Store</div>
                  </div>
                </a>
              </div>
            </div>

            {/* Right: Phone Mockup */}
            <div className="hidden lg:block relative h-full min-h-[400px] bg-[#F7F8FA]">
              <div className="absolute right-0 bottom-0 w-full h-full flex items-end justify-center pb-0">
                <img
                  src="https://images.unsplash.com/photo-1644794472051-36d154dfe487?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzbWFydHBob25lJTIwbW9ja3VwJTIwaGFuZHxlbnwxfHx8fDE3NjgyMDQxMjZ8MA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral"
                  alt="Mexmo app on phone"
                  className="h-96 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};